import { stylesheet } from 'typestyle';
import { flexRoot, horizontal } from 'csstips';

import { linkBlueText } from '@src/styles/general';

export default stylesheet({
  openTab: {
    border: '1px solid #e1e1e1 !important',
    borderBottom: '0 !important'
  },

  tab: {
    height: 58,
    margin: '9px 40px 0 17px',
    paddingTop: 11,

    textAlign: 'center',

    background: 'white',

    fontSize: 14,
    lineHeight: '25px',
    color: '#7f7f7f',

    border: '1px solid transparent',
    borderBottom: '1px solid #e1e1e1',

    cursor: 'pointer',

    zIndex: 1,

    '@media (min-width: 1001px) and (max-width: 1040px)': {
      marginRight: 30
    },

    '@media (min-width: 961px) and (max-width: 1000px)': {
      marginRight: 20
    },

    '@media (min-width: 921px) and (max-width: 960px)': {
      marginRight: 10
    },

    '@media (max-width: 920px)': {
      marginRight: 0
    },

    '@media (min-width: 866px) and (max-width: 890px)': {
      marginLeft: 10
    },

    '@media (max-width: 865px)': {
      marginLeft: 5
    }
  },

  section: {
    display: 'inline-block',

    position: 'relative'
  },

  contentDropdown: {
    position: 'absolute',
    top: 67,

    margin: 0,
    marginLeft: 17,
    padding: '14px 2px',
    background: 'white',

    border: '1px solid #e1e1e1',
    borderTop: 0,

    zIndex: 1,

    '@media (max-width: 890px)': {
      marginLeft: 10
    },

    '@media (max-width: 865px)': {
      marginLeft: 5
    },

    $nest: {
      '& li, & label': {
        position: 'relative',
        fontSize: 13,
        lineHeight: '25px',
        color: '#7f7f7f'
      },

      '&, & ul': {
        listStyleType: 'none'
      },

      '& ul': {
        margin: 0,
        padding: 0
      },

      '& > li:last-of-type': {
        marginBottom: 0
      },

      '& > li': {
        marginBottom: 2
      },

      '& [type=checkbox]': {
        display: 'none'
      },

      '& [type=checkbox] + label': {
        position: 'relative',
        paddingLeft: 24
      },

      '& [type=radio]': {
        display: 'none'
      },

      '& [type=radio] + label': {
        position: 'relative',
        paddingLeft: 24
      }
    }
  },

  filterLabelImage: {
    position: 'absolute',
    top: 7,
    right: 9,
    height: 13
  },

  filterLabel: {
    position: 'relative',

    $nest: {
      '&::before': {
        content: `''`,
        position: 'absolute',
        display: 'inline-block',
        width: 14,
        height: 14,
        border: '1px solid #e1e1e1',
        borderRadius: 4,
        top: 7,
        left: 0
      }
    }
  },

  checkedFilterLabel: {
    position: 'relative',

    $nest: {
      '&::before': {
        content: `''`,
        position: 'absolute',
        display: 'inline-block',
        width: 14,
        height: 14,
        border: `1px solid ${linkBlueText}`,
        borderRadius: 4,
        top: 7,
        left: 0
      },

      '&::after': {
        content: `''`,
        position: 'absolute',
        display: 'inline-block',
        width: 8,
        height: 8,
        background: linkBlueText,
        borderRadius: 3,
        top: 10,
        left: 3
      }
    }
  }
});
